import { render, staticRenderFns } from "./addBrake.vue?vue&type=template&id=f46f2f4e&scoped=true&"
import script from "./addBrake.vue?vue&type=script&lang=js&"
export * from "./addBrake.vue?vue&type=script&lang=js&"
import style0 from "./addBrake.vue?vue&type=style&index=0&id=f46f2f4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46f2f4e",
  null
  
)

export default component.exports